var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "raphael:dollar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 3C7.02938 3 3 7.02938 3 12C3 16.9706 7.02938 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02938 16.9706 3 12 3ZM12.7771 16.8796V18.1472H11.5647V16.8938C9.57507 16.6214 8.7038 14.9866 8.7038 14.9866L9.94227 13.9506C9.94227 13.9506 10.733 15.3272 12.1635 15.3272C12.9536 15.3272 13.553 14.9042 13.553 14.1816C13.553 12.4923 9.00165 12.6973 9.00165 9.5633C9.00165 8.20098 10.0791 7.21949 11.5641 6.98727V5.72093H12.7765V6.98727C13.8119 7.1235 15.038 7.66843 15.038 8.84065V9.73978H13.4304V9.30384C13.4304 8.85427 12.8576 8.55456 12.2167 8.55456C11.3993 8.55456 10.8005 8.96326 10.8005 9.53543C10.8005 11.2656 15.3519 10.8433 15.3519 14.1271C15.3519 15.477 14.3438 16.6474 12.7771 16.8796Z",
    fill: "#15318D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE6);
export default __webpack_public_path__ + "static/media/e6.b539f6c6af67c660b38691e911778a51.svg";
export { ForwardRef as ReactComponent };